module.exports = __webpack_public_path__ + "img/icon_vs.0470ae3c.png";